import React from "react";
import logo from "../Assets/logos/logo-rmbg.png"; 
import "./StaffLineLogo.css";

const StaffLineLogo = () => {
  return (
    <div className="staffline-logo">
      <img src={logo} alt="StaffLine Transport Logo" />

      <div className="staffline-logo-text">
        <span className="staffline-logo-main">StaffLine</span>
        <span className="staffline-logo-sub">Transport</span>
      </div>
    </div>
  );
};

export default StaffLineLogo;